import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getNeptuneStructuredData() {
  const url = "https://restorehair.com/locations/new-jersey/neptune/";
  const description =
    "Find out about your hair transplant options in Neptune with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("neptune", url, description),
    locationPageCrumbs(url, "Neptune"),
  ];
}
